import { Component, OnInit, Input } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { PollService } from '@services/poll.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
@Component({
  selector: 'app-dcreatequestion',
  templateUrl: './dcreatequestion.component.html',
  styleUrls: ['./dcreatequestion.component.sass']
})
export class DcreatequestionComponent implements OnInit {
  @Input() qparam;
  @Input() pollId;
  appCreateForm: FormGroup;
  component = "";
  application = "";
  response: any = [];
  status = "";
  error: any = {};
  btn_process=false;
  status_list:any=[];
  constructor(private _formdataService: FormdataService,private router: Router, private _save: PollService, private _viewService: ViewService, private fb: FormBuilder, private _global: GlobalService, public ngxSmartModalService: NgxSmartModalService) {

    this.appCreateForm = this.fb.group({
      name: [],
      description: [],
      status:[],
    });
    this.component = this._global.COMPONENTS_SMN;
    this.application = 'poll';

    let f = {
      'component': this.component,
      'application': this.application
    };
   
      this._formdataService.common(f, 'listStatusTypes').subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.status_list = this._global.getVal(data, 'response', '');
          }
          this.appCreateForm.get('status').setValue('active');
        },
        error => {
          console.log("error", JSON.stringify(error));
        });

  }

  ngOnInit() {
  }
  ngOnChanges() {
    this.error={};

  }
  save() {
    this.btn_process=true;
    this.error= {};
    let r = this.appCreateForm.value;
    r.component=this.component;
    r.application=this.application;
    r=this._global.paramsRemoveNull(r);
    r.pollId=this.pollId;
    this._save.createQuestion(r ).subscribe(
      data => {
        this.btn_process=false;
        let severity='success';
        let message='';
        if(this._global.getVal(data, 'status', '')==1){
          message=this._global.getVal(data, 'message.info', '');
          this._global.showMessage({type:severity,message:message});
          this.ngxSmartModalService.getModal('quescreate').close();
        }else{
          this.btn_process=false;
          message=this._global.getVal(data, 'message.error', '');
          severity='danger';
          for (let key in data["errors"]) {
            
            this.error[key] =this._global.getVal(data, 'errors.'+key+'.message', '');
            
          }
          this._global.showMessage({type:severity,message:message});
        }
      
      },
      error => {
        console.log("error", JSON.stringify(error));
      });


  }

}
